const item = (id, type, extra = {}) => ({
	id: `branding-${id}`,
	type,
	required: false,
	fieldName: `Field${id}`,
	schemaMapping: null,
	conditions: [],
	conditionalType: 'and',
	conditionsEnabled: false,
	...extra,
});

export function createFormBrandingFixture() {
	const firstName = item(7, 'TextInput', { question: 'First name', placeholder: 'Jane', schemaMapping: 'firstName', required: true });
	const lastName = item(8, 'TextInput', { question: 'Last name', placeholder: 'Doe', schemaMapping: 'lastName', required: true });
	return {
		id: '642356ec35707318aa08bd18',
		accountId: 'branding-harness-account',
		name: 'Client intake — full discovery',
		schemaVersion: 2,
		uniqueTemplateId: 'branding-harness-no-persistence',
		font: 'Roboto',
		accountLogo: `${window.location.origin}/form-branding-logo.svg`,
		reCaptchaEnabled: true,
		confirmationText: '<p style="color:#eeeeee"><strong>Thanks!</strong> Your details are ready for review.</p>',
		confirmationRedirect: null,
		formSettingsV2: {
			fontSize: 14,
			inputStyle: 'outlined',
			fontColor: '#25312d',
			maxWidth: 900,
			backgroundColor: '#ffffff',
			formInputColor: '#ffffff',
			buttonColor: '#5c00e2',
			buttonTextColor: '#ffffff',
			buttonSize: 'Normal',
			buttonStyle: 'Normal',
			submitText: 'Submit',
			submitIcon: 'send',
			submitAlignment: 'RIGHT',
			prevPageIcon: 'arrow_back',
			prevPageText: 'Previous',
			nextPageIcon: 'arrow_forward',
			nextPageText: 'Next',
			customCss: '.form-question { text-decoration: underline; }',
		},
		schemaV2: [
			item(1, 'Logo', { width: 180, align: 'center' }),
			item(2, 'TextBlock', { text: '<h2 style="color:#ededed">Tell us about your business</h2><p>Every renderer element is represented in this fixture.</p>' }),
			item(3, 'TextInput', { question: "What's your business name?", placeholder: 'Acme Co.', schemaMapping: 'businessName', required: true }),
			item(4, 'TextInput', { question: 'Your email', placeholder: 'you@company.com', validateFor: 'Email', schemaMapping: 'email', required: true }),
			item(5, 'TextInput', { question: 'Your phone', placeholder: '+1 555 123 4567', validateFor: 'Phone', schemaMapping: 'phone' }),
			item(6, 'Select', { question: 'How did you hear about us?', placeholder: 'Choose one', options: ['Referral', 'Search', 'Social media', 'Other'] }),
			item(9, 'NewPage', { nextText: 'Next', backText: 'Previous', alignment: 'JUSTIFIED' }),
			item(10, 'Container', {
				columnCount: 2,
				columns: [
					{ pt: 0, pb: 0, pr: 8, pl: 0, items: [firstName] },
					{ pt: 0, pb: 0, pr: 0, pl: 8, items: [lastName] },
				],
			}),
			item(11, 'Radio', { question: 'Which service are you interested in?', options: ['Design', 'Development', 'Both'], formatVertically: true }),
			item(12, 'Checkbox', { question: 'Which tools do you use?', options: ['CRM', 'Analytics', 'Marketing automation'], formatVertically: false }),
			item(13, 'TextArea', { question: 'Tell us more', placeholder: 'The more detail the better…', rows: 4 }),
			item(14, 'DateInput', { question: 'Preferred contact date', placeholder: 'Choose a date' }),
			item(15, 'FileInput', { question: 'Upload briefs (optional)', placeholder: 'PDF or Word docs', multi: true, fileTypes: ['pdf', 'doc', 'docx'] }),
			item(16, 'Divider', { style: 'solid', color: '#718078', weight: 1, width: 100, pt: 10, pb: 10 }),
			item(17, 'Spacer', { height: 20 }),
			item(18, 'ImageBlock', { pt: 0, pb: 8, br: 4, scale: 80, alignment: 'center', url: null, width: 480 }),
			item(19, 'Button', { alignment: 'center', redirectUrl: null, text: 'Secondary action', size: 'Normal', style: 'Normal', color: '#eeeeee', textColor: '#111111' }),
		],
	};
}
